<script setup>
import { ref } from 'vue'
import { reportService } from '@/http'

const props = defineProps(['type', 'id'])

const form = ref({})

const isSend = ref(false)

const onSend = () => {
    //console.log(props.id)
    reportService.save({
        target_id: props.id,
        type: props.type,
        ...form.value
    }).then(res => {
        isSend.value = true
    })
    //isSend.value = true
}


</script>

<template>
    <div>
        <div class="comments__moder" v-if="isSend">
            Жалоба отправлена на модерацию
        </div>
        <form action="" v-else class="comments__form" @submit.prevent="onSend">
            <textarea class="textarea" v-model="form.text" placeholder="Причина" required></textarea>
            <button class="btn btn--full" type="submit">Отправить</button>
        </form>
    </div>
</template>


<style lang="scss">
.textarea {
    display: flex;
    min-height: 150px;
    padding: 14px;
    border: 1px solid var(--border);
    border-radius: var(--border-radius);
    position: relative;
}
</style>